import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  Badge,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { useSelector, useDispatch } from "react-redux"
import { deleteJackpot } from "store/jackpots/actions"
import {
  convertToDateTimeString,
  hasPermission,
  numberWithCommas,
} from "helpers/helpers"

function Table(props) {
  const { data } = props

  const dispatch = useDispatch()

  const handleEdit = (row, e) => {
    e.preventDefault()
    props.history.push(`${window.location.pathname}/edit?id=${row.id}`)
  }
  const handleView = (row, e) => {
    e.preventDefault()
    props.history.push(`${window.location.pathname}/view?id=${row.id}`)
  }
  const columns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Created Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "250px" }
      },
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      text: "Channels",
      sort: true,
      style: { whiteSpace: "break-spaces" },
      formatter: (cellContent, row) => {
        return (
          <>
            {row.channels.map((s, index) => {
              return (
                <Link
                  to="#"
                  className="badge badge-soft-primary font-size-11 m-1"
                  key={"_skill_" + s.id + index}
                >
                  {s.name}
                </Link>
              )
            })}
          </>
        )
      },
    },
    {
      text: "Market",
      dataField: "market",
      sort: true,
    },
    {
      text: "Prizes",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <>
          <p className="mb-1 fw-bold">{numberWithCommas(row.max_price)}</p>
          <p className="mb-0 fw-bold">{numberWithCommas(row.n_1)}</p>
          <p className="mb-0 fw-bold">{numberWithCommas(row.n_2)}</p>
        </>
      ),
    },
    {
      dataField: "price_per_ticket",
      text: "Price",
      sort: true,
      formatter: (cellContent, row) => (
        <>
          <p>{numberWithCommas(row.price_per_ticket)}</p>
        </>
      ),
    },
    {
      dataField: "is_active",
      text: "Active",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        return (
          <>
            {row.is_active ? (
              <Badge color="success" className="bg-success font-size-12">
                <i className="mdi mdi-check-bold" />
              </Badge>
            ) : (
              <Badge color="danger" className="bg-danger font-size-12">
                <i className="mdi mdi-close" />
              </Badge>
            )}
          </>
        )
      },
    },

    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <>
          {row?.is_started_or_finish != 1 ? (
            <div className="d-flex gap-3">
              {hasPermission("update-jackpots") && (
                <Link
                  to="#"
                  className="text-success"
                  onClick={e => handleEdit(row, e)}
                >
                  <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </Link>
              )}

              {hasPermission("delete-jackpots") && (
                <Link
                  to="#"
                  className="text-danger"
                  onClick={e => {
                    dispatch(deleteJackpot(row.id))
                  }}
                >
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                  />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              )}
            </div>
          ) : (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-primary"
                onClick={e => handleView(row, e)}
              >
                <i className="mdi mdi-eye font-size-18" />
              </Link>
            </div>
          )}
        </>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: 10,
    totalSize: data.length,
    custom: true,
  }

  const handleClick = () => {
    props.history.push("/promotions/jackpots/create")
  }
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Jackpots"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="4">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <SearchBar {...toolkitProps.searchProps} />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </Col>
                      <Col sm="8">
                        {hasPermission("create-jackpots") && (
                          <div className="text-sm-end">
                            <Button
                              type="button"
                              color="success"
                              className="btn-rounded  mb-2 me-2"
                              onClick={handleClick}
                            >
                              <i className="mdi mdi-plus me-1" />
                              Create Jackpot
                            </Button>
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            //   selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  )
}

export default withRouter(Table)
